<template>
    <div style="min-height:300px; height:300px; min-width:100%; width:100%;">
        <div class="d-flex detail-map-placeholder justify-content-center align-items-center" v-if="!show">
            <button class="btn btn-primary" @click.prevent.stop="showMap">{{'map.show_map' | trans}}</button>
        </div>
        <gmap-map
                v-else
                :center="{lat:this.lat, lng:this.lng}"
                :zoom="zoom"
                map-type-id="roadmap"
                class="detail-map"
        >
            <gmap-marker
                    :position="{lat:this.lat, lng:this.lng}"
            ></gmap-marker>
        </gmap-map>
    </div>
</template>

<script>
    export default {
        props: {
            lat: {
                default: 0
            },
            lng: {
                default: 0
            },
            zoom: {
                default: 10
            }
        },
        data: function () {
            return {
                show: false
            }
        },
        methods: {
            showMap: function () {
                this.show = true;
            }
        }
    };
</script>
